/* unplugin-vue-components disabled */import { render } from "./userAvatar.vue?vue&type=template&id=50093aa0&scoped=true"
import script from "./userAvatar.vue?vue&type=script&lang=js"
export * from "./userAvatar.vue?vue&type=script&lang=js"

import "./userAvatar.vue?vue&type=style&index=0&id=50093aa0&scoped=true&lang=scss"

import exportComponent from "/Users/haonanzeng/Desktop/PigGTEx-Portal/piggtex-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50093aa0"]])

export default __exports__